'use strict';

import FormController from 'app/controllers/form';

class FleetController extends FormController {
  static $inject = [
    'FleetsService',
    '$scope',
    '$mdDialog',
    '$mdToast',
    '$state',
    '$location'
  ];
  btnEnabled: boolean = true;
  constructor(FleetsService, $scope, $mdDialog, $mdToast, $state, $location) {
    super(
      $scope.$parent.$resolve.fleet,
      'Flota',
      FleetsService,
      null,
      'fleets'
    );

    Object.assign(this, {
      FleetsService,
      $mdDialog,
      $mdToast,
      $state,
      $location
    });
  }
}

export default FleetController;
